<script lang="ts" setup>
  import { TEST_ID } from './CounterButton.constants'

  interface Props {
    disabled?: boolean
  }

  withDefaults(defineProps<Props>(), {
    disabled: false,
  })

  const emit = defineEmits<Emits>()
  interface Emits {
    (e: 'click'): void
  }
  const onClick = () => {
    emit('click')
  }
</script>

<template>
  <div
    class="counter-button"
    :class="{ 'counter-button--disabled': disabled }"
    :data-testid="TEST_ID"
    @mousedown.prevent="onClick"
  >
    <slot></slot>
  </div>
</template>

<style lang="scss">
  @import './CounterButton';
</style>
